module.exports = __webpack_public_path__ + "assets/images/project/head/Adamas_Belva_Syah_Devara.jpg?v=2830939a";